import axios from "axios";
import moment from "moment-timezone";

import { getStore } from "store";

import api from "services/api";

// Id	  Operation	  Description
// 1	  1	          Inserção
// 2	  2	          Atualização
// 3	  3	          Exclusão
// 4	  4	          Login
// 5	  5	          Logoff
// 6	  6	          Exportação
// 7	  7	          Importação
// 8	  8	          Gravação
// 9	  9	          Visualização
// 10	  10	        Publicação

export const LogOperation = {
  async postLogOperation(
    systemObject: string,
    operation: number,
    registerId: number,
  ) {
    const state = getStore().getState().user;
    const dateOperation = moment.tz("America/Sao_Paulo");
    try {
      const postLogger = {
        policeUnitId: this.getPoliceUnitId(),
        userId: state?.user?.id,
        registerId: registerId,
        date: dateOperation.format("YYYY-MM-DDTHH:mm:ss"),
        systemObject: systemObject,
        operation: operation,
        device: this.getDevice(),
        ip: this.getMachineIP(),
        createIn: dateOperation.format("YYYY-MM-DDTHH:mm:ss"),
      };
      await api.post("/v1/LogOperation/Add", postLogger);
    } catch (error) {
      console.log("error", error);
    }
  },
  getUserId: () => {
    const state = getStore().getState().user;
    return state?.user?.id;
  },
  getCustomerId: (): number => {
    const state = getStore().getState().user;
    return state?.user?.customerId;
  },
  getDevice: (): string => {
    return "Todos";
  },
  getPoliceUnitId: () => {
    const unitStorage = getStore().getState().profile;
    return unitStorage?.userCustomerProfile?.placeId;
  },
  getMachineIP: (): string => {
    return localStorage.getItem("MachineIP") || "";
  },
  setMachineIP: async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");

      if (res.data && res.data.ip) {
        localStorage.setItem("MachineIP", res.data.ip);
      } else {
        throw new Error("IP não encontrado na resposta");
      }
    } catch (error) {
      console.error("Erro ao buscar IP público:", error);
      localStorage.setItem("MachineIP", "Não encontrado");
    }
  },
};
